import { ITheme, mediaQuery } from '@quicktools/shared-components';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  ({ colors, breakpoints }: ITheme) => ({
    root: {
      backgroundColor: 'var(--x-bg-5)',
    },
    container: {
      maxWidth: 1360,
      marginInline: 'auto',
      paddingBlock: 48,

      [mediaQuery(breakpoints.desktop)]: {
        padding: [40, 24],
      },
    },
    header: {
      textAlign: 'center',
    },

    title: {
      marginBottom: 8,

      [mediaQuery(breakpoints.mobile)]: {
        fontSize: 30,
        fontWeight: 500,
      },
    },

    description: {
      color: '#5F5F5F',
    },

    tools: {
      maxWidth: '100%',
      display: 'grid',
      gap: 18,
      gridTemplateColumns: '1fr 1fr 1fr',

      [mediaQuery(breakpoints.laptop)]: {
        gridTemplateColumns: '1fr 1fr',
      },
      [mediaQuery(breakpoints.tablet)]: {
        gridTemplateColumns: '1fr',
      },
    },

    buttonToggle: {
      borderColor: 'transparent',
      marginBlock: 24,
      marginInline: 'auto',
      width: 666,

      '& > div > button': {
        '&:hover': {
          color: `${colors.black} !important`,
        },
      },

      [mediaQuery(breakpoints.tablet)]: {
        '& > div': {
          width: 666,
        },
      },
    },

    cards: {
      display: 'grid',
      gap: 18,
      gridTemplateColumns: '1fr 1fr 1fr',

      [mediaQuery(breakpoints.laptop)]: {
        gridTemplateColumns: '1fr 1fr',
      },
      [mediaQuery(breakpoints.tablet)]: {
        gridTemplateColumns: '1fr',
      },
    },

    openBtnContainer: {
      marginTop: 32,
      textAlign: 'center',
    },
  }),
  { name: 'CopywriterToolsSection' },
);

export default useStyles;
